<template>
  <transition name="slide-fade">
    <div>
      <form @submit.prevent="attachRole(role)">
        <v-select label="Select Role" v-model="role" required="required" :error-messages="_error('user_id', 'attachRoleUser')" item-text="name" item-value="id" :items="roles" autocomplete>
          <template v-slot:item="{ active, item, attrs, on }">
            <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
              <v-list-item-content>
                <v-list-item-title>
                  <span>{{ item.name }}</span>
                </v-list-item-title>
                <v-list-item-subtitle>
                  <span>{{ item.label }}</span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
        <v-btn type="submit" color="primary" small class="pull-right">Submit</v-btn><br>
      </form>
    </div>
  </transition>
</template>
<script>
  export default {
    name: 'AttachRoleToUser',
    props: ['user', 'roles'],
    data () {
      return {
        role: '',
        attaching: false,
      }
    },
    methods: {
      attachRole (role) {
        swal({
          title: 'Attach Role to user',
          text: 'The user will inherit all permissions attached to this role',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'red',
          confirmButtonText:'Attach',
        },
        function () {
          this.attaching = true
          this.$inertia.post('/admin/roles/' + role + '/users/' + this.user.id + '/attach', {
            preserveScroll: true,
          })
        }.bind(this))
      }
    },
  }
</script>
